import { Button, FormInstance } from 'antd'
import { FC } from 'react'
import Stamp from '../../../../../../../../../types/api/stamp'
import { dynamicRoutes, routes } from '../../../../../../../../../constants/routes'
import useErrorModal from '../../../../../../../../../hooks/api/use-error-modal'
import useShowStandardSuccessModal from '../../../../../../../../../hooks/use-show-standard-success-modal'
import {
    useCreateStampMutation,
    useUpdateStampMutation,
} from '../../../../../../../../../store/api/stamps-api'
import useExtractCreateStampMutationArg from '../../hooks/use-extract-create-stamp-mutation-arg'

interface SaveProps {
    stamp?: Stamp
    copy?: boolean
    form: FormInstance
}

const Save: FC<SaveProps> = ({ stamp, copy, form }) => {
    const showSuccessModal = useShowStandardSuccessModal('Штамп сохранен', form)
    const [createStamp, createStampState] = useCreateStampMutation()
    const [updateStamp, updateStampState] = useUpdateStampMutation()
    const extractCreateStampMutationArg = useExtractCreateStampMutationArg(form)

    useErrorModal(createStampState, 'Не удалось сохранить штамп')
    useErrorModal(updateStampState, 'Не удалось обновить штамп')

    const onSave = async () => {
        try {
            await form.validateFields()
            const body = extractCreateStampMutationArg()
            const isEditing = stamp && !copy

            let result = null
            if (isEditing) result = await updateStamp({ docId: stamp.documentId, body })
            else result = await createStamp(body)

            if ('data' in result && result.data) {
                const { documentId } = result.data.data
                showSuccessModal({
                    listRoute: routes.equipmentStamps,
                    editingRoute: dynamicRoutes.equipmentStamp(documentId),
                })
            }
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Button
            type={'primary'}
            loading={createStampState.isLoading || updateStampState.isLoading}
            onClick={onSave}
        >
            Сохранить
        </Button>
    )
}

export default Save
